"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _asyncRetry = _interopRequireDefault(require("async-retry"));
/**
 * Wrapper class for the hls.js library.
 *
 * Documentation here:
 *  https://github.com/video-dev/hls.js/blob/master/docs/API.md
 */
var HlsJs = exports["default"] = /*#__PURE__*/function () {
  function HlsJs(fetchHlsJsLibrary) {
    (0, _classCallCheck2["default"])(this, HlsJs);
    this.fetchHlsJsLibrary = fetchHlsJsLibrary;
    this.hlsJsInstance = null;
    this.Events = {};
    this.listeners = [];
  }
  (0, _createClass2["default"])(HlsJs, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var HlsJSLibrary;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _asyncRetry["default"])(this.fetchHlsJsLibrary, {
                retries: 3
              });
            case 2:
              HlsJSLibrary = _context.sent;
              if (HlsJSLibrary) {
                _context.next = 5;
                break;
              }
              throw new Error('could not load hls.js library');
            case 5:
              this.hlsJsInstance = new HlsJSLibrary({
                autoStartLoad: false
              });
              this.Events = HlsJSLibrary.Events;
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "addEventListener",
    value: function addEventListener(eventName, callback) {
      var once = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var event = this.Events[eventName];
      if (!event) {
        return;
      }
      if (once) {
        this.hlsJsInstance.once(event, callback);
        return;
      }
      this.hlsJsInstance.on(event, callback);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventName, callback) {
      var event = this.Events[eventName];
      if (event) {
        this.hlsJsInstance.off(event, callback);
      }
    }

    /**
     * Method to attach the videoElement to the hls.js library so the
     * HLS manifest segments can be injected into the video element's source
     * buffer.
     * @param videoElement {HTMLVideoElement}
     * @returns {Promise<any>}
     */
  }, {
    key: "attachMedia",
    value: function attachMedia(videoElement) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        _this.listeners.push({
          event: _this.Events.MEDIA_ATTACHED,
          callback: resolve
        });
        _this.listeners.push({
          event: _this.Events.ERROR,
          callback: reject
        });
        _this.hlsJsInstance.once(_this.Events.MEDIA_ATTACHED, resolve);
        _this.hlsJsInstance.once(_this.Events.ERROR, reject);
        _this.hlsJsInstance.attachMedia(videoElement);
      });
    }

    /**
     * Method to load the HLS manifest specified by the url, and then start to load
     * the manifest fragments starting at the live head. We are using 0 as the default position
     * for live streams and in cases of VOD (LiveSeek) we use -1 as the default position to get
     * us to the current live head position.
     *
     * Documentation:
     *  https://github.com/video-dev/hls.js/blob/master/docs/API.md#startposition
     *
     * @param url {string} HLS manifest url
     * @param position {number} position to start playing the HLS manifest
     * @param isLiveSeek {boolean} is the loaded source from a Live Seek Player or not
     * @returns {Promise<void>}
     */
  }, {
    key: "loadSource",
    value: (function () {
      var _loadSource = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(url, position, isLiveSeek) {
        var _this2 = this;
        var defaultStartPos, startingPosition;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              defaultStartPos = isLiveSeek ? -1 : 0;
              startingPosition = typeof position === 'number' ? position : defaultStartPos;
              _context2.next = 4;
              return new Promise(function (resolve, reject) {
                _this2.listeners.push({
                  event: _this2.Events.MANIFEST_PARSED,
                  callback: resolve
                });
                _this2.listeners.push({
                  event: _this2.Events.ERROR,
                  callback: reject
                });
                _this2.hlsJsInstance.once(_this2.Events.MANIFEST_PARSED, resolve);
                _this2.hlsJsInstance.once(_this2.Events.ERROR, reject);
                _this2.hlsJsInstance.loadSource(url);
              });
            case 4:
              this.hlsJsInstance.startLoad(startingPosition);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadSource(_x, _x2, _x3) {
        return _loadSource.apply(this, arguments);
      }
      return loadSource;
    }())
  }, {
    key: "off",
    value: function off() {
      var _this3 = this;
      this.listeners.forEach(function (listener) {
        return _this3.hlsJsInstance.off(listener.event, listener.callback);
      });
      this.listeners = [];
    }
  }, {
    key: "detachMedia",
    value: function detachMedia() {
      this.hlsJsInstance.detachMedia();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this.hlsJsInstance.destroy();
    }
  }]);
  return HlsJs;
}();
//# sourceMappingURL=HlsJs.js.map